import React, { Component, useState, useMemo, useEffect, useRef } from "react";
import DefaultDataGrid from './DefaultDataGrid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Menu, MenuItem, Box, IconButton, CircularProgress, TableBody, TableCell, TableRow, Grid, Divider, Table, Autocomplete, DialogContent, Tooltip, Checkbox } from '@mui/material';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject, TokenData } from '../App';
import InputColumn from './InputColumn'
import InputRow from './InputRow'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import TabManager from "./TabsInput";
import { Container, Divide } from "tabler-icons-react";
import AutocompleteText from "./AutocompleteText"
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { ChatBox, Message } from "./ChatBox";
import { productStatusToInfo } from "../pages/Orders";
import { useReactToPrint } from "react-to-print";
import { DataGrid, GridActionsCellItem, GridToolbarContainer } from "@mui/x-data-grid";
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import PrintIcon from '@mui/icons-material/Print';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { useOnMount } from "@mui/x-data-grid/internals";
const ComponentToPrint = React.forwardRef((props, ref) => {
    const { product, data, order } = props;

    function WZTable(props) {
        return <Table sx={{
            marginTop: "20px",
            borderCollapse: "collapse",
            "& td": {
                border: "solid black 2px",
                textAlign: "center"
            }, width: "100%"
        }} >{props.children}</Table >
    }

    let issuingPerson = (data.other && data.other.issuing_employee) ? data.other.issuing_employee : (data.issuing_employee ? data.issuing_employee : "Do wyboru przy wydrukowaniu");
    return (
        <Grid item container ref={ref} style={{ padding: "40px" }}>
            <WZTable>
                <tbody>
                    <tr style={{ backgroundColor: "grey" }}>
                        <td rowspan="6" width="22%" style={{ fontSize: "45px", fontWeight: "bolder" }}><i>WZ</i></td>
                        <td width="20%">Dane wykonawcy:</td>
                        <td>Patent druk</td>
                    </tr>
                    <tr>
                        <td>Dane odbiorcy:</td>
                        <td>{order.client.invoice.company}</td>
                    </tr>
                    <tr>
                        <td>Nr Zamówienia:</td>
                        <td><b>{order["_id"]}</b></td>
                    </tr>
                    {/* <tr>
                        <td>Id produktu:</td>
                        <td>{product.id}</td>
                    </tr> */}
                    <tr>
                        <td>Data:</td>
                        <td>{new Date().toLocaleDateString()}</td>
                    </tr>
                    <tr>
                        <td>Osoba wydająca:</td>
                        <td>{issuingPerson}</td>
                    </tr>
                </tbody>
            </WZTable>
            <WZTable>
                <tbody>
                    <tr style={{ backgroundColor: "grey" }}>
                        <td width="4%">LP</td>
                        <td >Nazwa towaru</td>
                        <td width="10%">Ilość</td>
                        <td width="10%">Jm</td>
                    </tr>
                    {
                        Object.keys(data.products).map((key, index) => <tr>
                            <td>{index + 1}</td>
                            <td>{data.products[key].product_name}</td>
                            <td>{data.products[key].quantity}</td>
                            <td>szt</td>
                        </tr>)
                    }
                </tbody>
            </WZTable>
            <WZTable>
                <tbody>
                    <tr height="50px">
                        <td></td>
                        <td></td>
                        <td>{issuingPerson}</td>
                    </tr>
                    <tr>
                        <td width="40%">Imię i Nazwisko odbierającego</td>
                        <td width="25%">Data odbioru</td>
                        <td width="15%">Podpis</td>
                    </tr>
                </tbody>
            </WZTable>
        </Grid >
    );
});

function WZcardTable(props) {
    const userPermissions = (React.useContext(TokenData)).permissions;
    const [productionEmployees, setProductionEmployees] = useState(props.productionEmployees ? props.productionEmployees.map(employee => ({ label: employee.name, value: employee.name })) : undefined);
    const [dialogData, setDialogData] = useState({
        "products": {
            "0": { issuing_employee: undefined, product_name: undefined, quantity: undefined }
        },
        "other": { "issuing_employee": undefined }
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const { product, order, orderId } = props;

    useEffect(() => {
        if (!productionEmployees) query("/mysql/pracownicy", "GET").then(res => setProductionEmployees(res.map(employee => ({ label: employee.name, value: employee.name }))));
    }, [])

    useEffect(() => {
        if (dialogData.print) {
            handleWZPrint();
            setDialogData({ ...dialogData, ...{ print: false, reloadAfterPrint: false } })
            console.log("asdasdas")
        }
    }, [dialogData])
    console.log(props.order.products.map(product => ({ label: product.product_name, value: product.product_name })))
    console.log(props.order)
    const WZinputs = [
        {
            type: AutocompleteText,
            props: {
                freeSolo: true,
                label: "Nazwa produktu", name: "product_name", required: true,
                options: (props.order.products.map(product => ({ label: product.product_name, value: product.product_name })))
            }
        },
        { type: TextField, props: { label: "Ilosc", name: "quantity", type: "number" } },
        { type: Checkbox, props: { label: "Odbiera kurier", name: "courier_pickup" } },
    ]
    const dialogClose = (bool) => setDialogOpen(false);
    const handleWZPrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => {
            if (dialogData.reloadAfterPrint) window.location.reload();
        }
    });
    let componentRef = useRef();
    function productsCellRenderer(props) {
        let products = props.formattedValue;
        if (Object.keys(products).length == 0) return <div></div>;
        return (
            <Table sx={{ width: "100%" }} size="small" aria-label="a dense table">
                <TableBody>
                    {
                        Object.keys(products).map((key, index) => {
                            if (products[key] && (products[key].product_name || products[key].quantity)) {
                                return (<TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&>td': { maxWidth: "100px", width: "100px", padding: "0px", wordBreak: "break-word" } }}
                                >
                                    <TableCell align="center">
                                        {products[key].product_name}
                                    </TableCell>
                                    <TableCell align="center">
                                        {products[key].quantity} szt
                                    </TableCell>
                                </TableRow>)
                            } else return <TableRow></TableRow>;
                        })
                    }
                </TableBody>
            </Table >
        )
    }

    function trackingRelationCellRenderer(props) {
        if (!order.WZ.tracking_relations || !order.WZ.tracking_relations[props.formattedValue]) return <div></div>;
        function ContextMenuTableCell(props) {
            const [contextMenu, setContextMenu] = React.useState(null);
            const handleContextMenu = (event) => {
                event.preventDefault();
                setContextMenu(
                    contextMenu === null
                        ? {
                            mouseX: event.clientX + 2,
                            mouseY: event.clientY - 6,
                        }
                        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                        // Other native context menus might behave different.
                        // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                        null,
                );
            };
            const handleClose = () => {
                setContextMenu(null);
            };
            return (<TableRow onContextMenu={handleContextMenu}
                sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&>td': { maxWidth: "100px", width: "100px", padding: "0px", wordBreak: "break-word" } }}
            >
                <TableCell align="center">
                    {props.tracking_number}
                </TableCell>
                <TableCell align="center">
                    {props.packages} paczek
                </TableCell>
                <TableCell align="center">
                    {props.pallets} palet
                </TableCell>
                <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                        contextMenu !== null
                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                            : undefined
                    }
                >
                    <MenuItem onClick={() =>
                        query(`/orders/${orderId}/trackingNumbers/delete`, 'PATCH', { uuid: props.uuid }).then(res => {
                            window.location.reload()
                        })}>Usun numer: {props.tracking_number}</MenuItem>
                </Menu>
            </TableRow>)
        }
        return (
            <Table sx={{ width: "100%" }} size="small" aria-label="a dense table">
                <TableBody>
                    {
                        order.WZ.tracking_relations[props.formattedValue].map((trackingUUID, index) => {
                            const tracking_number_data = order.transport.tracking_numbers.find(e => e.uuid == trackingUUID.uuid);
                            if (!tracking_number_data) return;
                            return (
                                <ContextMenuTableCell {...tracking_number_data} />
                            )
                        })
                    }
                </TableBody>
            </Table >
        )
    }

    return (
        <Grid xs={6} item >
            <Box className="container">
                <Typography variant="h5" textAlign="center">
                    Karta WZ
                </Typography>
                <Grid xs={12} item container>
                    {
                        <DataGrid
                            sx={{ height: "300px", marginBottom: "10px", '&, [class^=root]': { border: 'none' } }}
                            hideFooter={true}
                            slots={{
                                toolbar: () => {
                                    const handleClick = async () => {
                                        setDialogData({
                                            "products": {
                                                "0": { product_name: product.product_name, quantity: product.quantity }
                                            },
                                            "other": { "issuing_employee": undefined }
                                        })
                                        setDialogOpen(true)
                                    }

                                    return props.editable != false && (
                                        <GridToolbarContainer>
                                            <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                                                Dodaj karte
                                            </Button>
                                        </GridToolbarContainer>
                                    );

                                }
                            }}
                            getRowId={(e) => e.uuid}
                            getRowHeight={() => 'auto'}
                            rows={order.WZ ? (order.WZ.history ? order.WZ.history : []) : []}
                            columns={[
                                {
                                    field: 'issuing_employee',
                                    headerName: 'Osoba',
                                    width: 150,
                                },
                                {
                                    field: 'products',
                                    headerName: 'Produkty',
                                    width: 300,
                                    renderCell: productsCellRenderer
                                },
                                {
                                    field: 'uuid',
                                    headerName: 'Numery sledzenia',
                                    width: 300,
                                    renderCell: trackingRelationCellRenderer
                                },
                                {
                                    field: 'actions',
                                    type: 'actions',
                                    minWidth: 100,
                                    flex: 1,
                                    cellClassName: 'actions',//handleDeleteClick(id) handleEditClick(id)
                                    getActions: (params) => {
                                        const defaultActions = [<GridActionsCellItem
                                            icon={<Tooltip arrow title={`Drukuj`}><PrintIcon /></Tooltip>}
                                            onClick={() => {
                                                // Test(product, params);
                                                console.log(params.row)
                                                setDialogData({ ...params.row, ...{ print: true } })
                                            }}
                                            label="Otworz"
                                            className="textPrimary"
                                            color="inherit"
                                        />]

                                        const addTrackingNumber = <GridActionsCellItem
                                            icon={<Tooltip arrow title={`Dodaj numer sledzenia`}><AddLocationAltIcon /></Tooltip>}
                                            label="Dodaj numer sledzenia"
                                            onClick={() => {
                                                props.setWZcardUUID(params.row.uuid)
                                            }}
                                            color="inherit"
                                        />;

                                        const deleteAction = <GridActionsCellItem
                                            icon={<Tooltip arrow title={`Usun`}><DeleteIcon /></Tooltip>}
                                            label="Usun"
                                            onClick={() => query(`/orders/${orderId}/WZ/delete`, 'PATCH', { uuid: params.id }).then(res => {
                                                window.location.reload()
                                            })}
                                            color="inherit"
                                        />;

                                        if ((userPermissions['files']['edit'] || userPermissions.admin) && props.editable != false) {
                                            defaultActions.push(addTrackingNumber);
                                            defaultActions.push(deleteAction);
                                        }
                                        return defaultActions;
                                    }
                                }]} />
                    }
                </Grid>
            </Box>
            <div style={{ display: "none" }} ><ComponentToPrint order={order} product={product} data={dialogData} ref={componentRef} /></div>
            <Dialog
                open={dialogOpen}
                onClose={dialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                sx={{
                    "& MuiDialogActions-root": {
                        textAlign: "center"
                    }
                }}
                PaperProps={{
                    sx: {
                        height: "500px",
                    }
                }}
            >
                <DialogContent>
                    <Box className="container" sx={{ backgroundColor: "#ebebeb", marginBottom: "20px" }}>
                        <InputColumn fields={[{
                            type: AutocompleteText,
                            props: {
                                label: "Osoba wydajaca", name: "issuing_employee", required: true,
                                options: productionEmployees
                            }
                        }]} title={"Osoba wydająca"} data={dialogData.other} />
                    </Box>
                    {
                        Object.keys(dialogData.products).map(key => {
                            let productInputs = WZinputs;
                            // console.log(dialogData.products[key])
                            // productInputs[0].props.onChange = (event, value) => {
                            //     dialogData.products[key].quantity = (order.products.find(product => product.product_name == value.value).quantity)
                            //     let test = { ...dialogData }
                            //     console.log({ ...dialogData })
                            //     setDialogData({ ...dialogData })
                            // }
                            return (<Box className="container" sx={{ backgroundColor: "#ebebeb", marginBottom: "20px", position: "relative" }}>
                                <IconButton aria-label="delete" sx={{ position: "absolute", right: "5px", top: "5px" }}
                                    onClick={() => {
                                        delete dialogData.products[key];
                                        setDialogData({ ...dialogData })
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                                <InputColumn fields={WZinputs} data={dialogData.products[key]} sx={{
                                    padding: "10px",
                                }} xs={12} />
                            </Box>)
                        })
                    }
                    <Button onClick={() => {
                        console.log(dialogData)
                        dialogData.products[Object.keys(dialogData.products).length] = {};
                        setDialogData({ ...dialogData })
                        console.log(dialogData)
                    }} variant="contained">Dodaj produkt</Button>
                </DialogContent>
                <DialogActions style={{ justifyContent: "space-around", marginTop: "auto" }}>
                    <Button onClick={dialogClose}>Anuluj</Button>
                    <Button onClick={async () => {
                        console.log(dialogData)
                        await query(`/orders/${orderId}/WZ/add`, "PATCH", dialogData)
                        setDialogData({ ...dialogData, ...{ print: true, reloadAfterPrint: true } })
                    }} autoFocus>
                        Dodaj i drukuj
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid >
    )
}
function TrackingNumbersTable(props) {
    const userPermissions = (React.useContext(TokenData)).permissions;
    const defaultDialogData = {
        tracking_number: undefined, courier_name: undefined, comments: undefined,
        packages: undefined, pallets: undefined, WZcardUUID: undefined
    }
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState({ ...defaultDialogData });
    const { product, order, orderId } = props;


    const dialogClose = (bool) => {
        props.setWZcardUUID(undefined);
        setDialogOpen(false);
    }
    const dialogInputs = [
        { type: TextField, props: { label: "Numer sledzenia", name: "tracking_number" } },
        { type: TextField, props: { label: "Nazwa kuriera", name: "courier_name" } },
        { type: TextField, props: { label: "Uwagi", name: "comments" } },
        { type: TextField, props: { label: "Ilosc paczek", name: "packages", type: "number", value: 0 } },
        { type: TextField, props: { label: "Ilosc palet", name: "pallets", type: "number", value: 0 } },
    ]

    useEffect(() => {
        if (props.WZcardUUID) {
            setDialogData({ ...dialogData, ...{ WZcardUUID: props.WZcardUUID } });
            setDialogOpen(true);
        }
    }, [props.WZcardUUID])

    return (<Grid xs={6} item  >
        <Box className="container">
            <Typography variant="h5" textAlign="center">
                Sledzenie przesylki {props.WZcardUUID}
            </Typography>
            <Grid xs={12} item container>
                <DataGrid
                    sx={{
                        height: "300px", marginBottom: "10px", '&, [class^=root]': { border: 'none' }
                    }}
                    hideFooter={true}
                    slots={{
                        toolbar: () => {
                            const handleClick = async () => {
                                setDialogData({ ...defaultDialogData })
                                setDialogOpen(true)
                            }

                            return props.editable != false && (
                                <GridToolbarContainer>
                                    <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                                        Dodaj numer sledzenia
                                    </Button>
                                </GridToolbarContainer>
                            );

                        }
                    }}
                    getRowId={(e) => e.uuid}
                    getRowHeight={() => 'auto'}
                    rows={order.transport ? (order.transport.tracking_numbers ? order.transport.tracking_numbers : []) : []}
                    columns={[
                        {
                            field: 'tracking_number',
                            headerName: 'Numer',
                            width: 150,
                        },
                        {
                            field: 'courier_name',
                            headerName: 'Nazwa kuriera',
                            width: 150,
                        },
                        {
                            field: 'comments',
                            headerName: 'Uwagi',
                            width: 150,
                        },
                        {
                            field: 'packages',
                            headerName: 'Paczki',
                            width: 100,
                        },
                        {
                            field: 'pallets',
                            headerName: 'Palety',
                            width: 100,
                        },
                        {
                            field: 'actions',
                            type: 'actions',
                            minWidth: 100,
                            flex: 1,
                            cellClassName: 'actions',//handleDeleteClick(id) handleEditClick(id)
                            getActions: (params) => {
                                const deleteAction = <GridActionsCellItem
                                    icon={<Tooltip arrow title={`Usun`}><DeleteIcon /></Tooltip>}
                                    label="Usun"
                                    onClick={() => query(`/orders/${orderId}/trackingNumbers/delete`, 'PATCH', { uuid: params.id }).then(res => {
                                        window.location.reload()
                                    })}
                                    color="inherit"
                                />;

                                if ((userPermissions['files']['edit'] || userPermissions.admin) && props.editable != false) {
                                    return [deleteAction];
                                }
                                return [];
                            }
                        }]} />
            </Grid>
        </Box>
        <Dialog
            open={dialogOpen}
            onClose={dialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            sx={{
                "& MuiDialogActions-root": {
                    textAlign: "center"
                }
            }}
            PaperProps={{
                sx: {
                    height: "500px",
                }
            }}
        >
            <DialogContent>
                <InputColumn fields={dialogInputs} data={dialogData} title={'Dane sledzenia'} sx={{
                    padding: "10px",
                }} xs={12} />
            </DialogContent>
            <DialogActions style={{ justifyContent: "space-around", marginTop: "auto" }}>
                <Button onClick={dialogClose}>Anuluj</Button>
                <Button onClick={async () => {
                    await query(`/orders/${orderId}/trackingNumbers/add`, "PATCH", dialogData)
                    window.location.reload()
                }} autoFocus>
                    Dodaj numer
                </Button>
            </DialogActions>
        </Dialog>
    </Grid>)
}

export default class WZTrackingBundle extends React.Component {
    state = { WZcardUUID: '' }

    setWZcardUUID = (WZcardUUID) => {
        this.setState({ WZcardUUID: WZcardUUID });
    }

    render() {
        return (
            <Grid xs={12} item container spacing={3}>
                <WZcardTable {...this.props} setWZcardUUID={this.setWZcardUUID} />
                <TrackingNumbersTable  {...this.props} WZcardUUID={this.state.WZcardUUID} setWZcardUUID={this.setWZcardUUID} />
            </Grid >
        )
    }
}